<template>
  <VButton
    class="refresh"
    :title="title"
    theme="default"
    @click="emitReload"
  >
    <template #icon>
      <VIcon
        class="spinning"
        material="refresh"
      />
    </template>
  </VButton>
</template>

<style lang="scss" src="./VReloadButton.scss"/>

<script>
export default defineComponent({
	name:  'VReloadButton',

	props: {
		title: {
			type:    String,
			default: 'Обновить список',
		},
	},

	emits: ['renew-data'],

	methods: {
		emitReload() {
			this.$emit('renew-data');
		}
	}
});
</script>
